var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.initialized)?_c('div',{staticClass:"app-initializing"},[_c('div',{attrs:{"uk-spinner":"ratio: 3"}})]):[_c('router-view')],_c('div',{ref:"loginModal",staticClass:"login-modal",attrs:{"uk-modal":""}},[_c('div',{staticClass:"uk-modal-dialog uk-modal-body"},[_c('Login',{ref:"login",on:{"login":_vm.closeLoginDialog}})],1)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }